import React from 'react';
import Input from '../../components/Forms/Input2.jsx';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSend from 'material-ui/svg-icons/content/send';
import _ from 'underscore';

export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            $valid: false,
            $pristine: true,
            $touched: false,
            $invalid: true,
            $dirty: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    componentDidMount() {
        this.validateForm();
    }

    onFocus(next, e, value) {

        if (e && e.persist) e.persist();

        if (next) next(e, value);
    }

    onBlur(next, e, value) {

        if (e && e.persist) e.persist();

        if (next) next(e, value);
    }

    onChange(next, e, value) {
        this.validateForm();

        if (e && e.persist) e.persist();

        if (next) next(e, value);
    }

    onSubmit(action, e) {
        this.props.onSubmit();
    }

    validateForm() {
        let valid = true;

        _.keys(this.refs).forEach((item, index) => {           
            if(this.refs[item].state.$invalid)
                valid = false;
        });

        this.setState({$valid: valid, $invalid: !valid});
    }

    render() {
        const inputs = this.props.children.map((Input, index) => {
            Input = React.cloneElement(Input, {
                    onFocus: this.onFocus.bind(this,Input.props.onFocus),
                    onBlur: this.onBlur.bind(this, Input.props.onBlur),
                    onChange: this.onChange.bind(this, Input.props.onChange),
                    forceValidation: () => this.validateForm,
                    ref: Input.props.name,
            });
            
            return (
                <div key={index} className={Input.props.outerClassName}>
                    {Input}
                </div>
            );
        });

        let submit = null;

        if (this.props.submitButton) {
            submit = (
                <FloatingActionButton
                    disabled={this.state.$invalid}
                    style={{position: 'absolute', right:15, bottom: -70, zIndex: 2}}
                    onTouchTap={this.onSubmit.bind(this, 'submit')}>
                    <ContentSend />
                </FloatingActionButton>
            );
        }

        return (
            <form action="/" role="form" method="post" onSubmit={this.onSubmit}>
                <div className="row">
                   {inputs}
                </div>

                {submit}
            </form>
        );
        
    }
}



/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/Form.jsx
 **/